import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function abnValidator(control: AbstractControl): ValidationErrors | null {
  const abn: string | null = control.value ? formatAbn(control.value) : null;

  if (!abn || isNaN(Number(abn)) || abn.length !== 11 || calculateSum(abn) % 89 !== 0) {
    return { invalidABN: true };
  }

  return null;
}

export function duplicateAbnValidator(existingAbns: string[], initialAbn: string): ValidatorFn {
  const formattedInitial = formatAbn(initialAbn);
  const abnSet = new Set(existingAbns.map(formatAbn));

  return (control: AbstractControl): ValidationErrors | null => {
    const currentAbn = formatAbn(control.value);
    if (!currentAbn || currentAbn === formattedInitial) {
      return null;
    }
    return abnSet.has(currentAbn) ? { duplicateAbn: true } : null;
  };
}

function calculateSum(abn: string): number {
  const weights: number[] = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  return abn.split('').reduce((total: number, digit: any, index: number) => {
    !index && digit--;
    return total + digit * weights[index];
  }, 0);
}

function formatAbn(value: string): string {
  return value?.replace(/\s+/g, '') ?? '';
}
